import { addToCart, redirectToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { Reporter } from 'features/dataCapture';
import { decodePatternColorCombination } from 'features/scene7';
import { formatReferringSortData } from 'features/sort';
import { utagLinkPDP } from 'features/tealium';
import { trackAddToCartDy } from 'features/tealium/dynamicYield';
import { dataCaptureTimeout } from 'ui/config';
import { showErrorMessage } from 'utilities/errorMessage/desktop';

import dynamicImport from '../../../../features/webpack/dynamicImport.macro';

// TODO: create a task to refactor this module to use plain JS over jQuery
function initCart (isOpenBox, sortPath, sortPosition, sortSku, listType, searchSkuCount) {

	let addToCartReduceQty = () => {};
	if ($('#availInventory').html() || $('.inventoryAvailable').html()) {

		dynamicImport('desktop/product-limitedQuantity', '../limitedQuantity').then((module) => {

			addToCartReduceQty = module.addToCartReduceQty;

		});

	}

	let openQuantityReduced = () => {};
	if (window.checkQuantity) {

		dynamicImport('desktop/product-limitedQuantity', '../limitedQuantity').then((module) => {

			// Dynamic import is async so in most cases, helpers.openQuantityReduced would be a noop at this point
			// eslint-disable-next-line no-use-before-define
			if (typeof helpers !== 'undefined') {

				// eslint-disable-next-line no-use-before-define
				helpers.openQuantityReduced = module.openQuantityReduced;

			} else {

				openQuantityReduced = module.openQuantityReduced;

			}

		});

	}

	let addToCartRecordId;
	const ui = {
		pdAddToCart: document.querySelector('#pdAddToCart'),
		pdAddDimmer: document.querySelector('#CartAddDimmer'),
		pdAddMultiProduct: document.querySelector('#AddToCart_Multiproduct'),
		pdMultiProductRadio: document.querySelector('[name=MultiproductRadio]'),
		pdAddToCartSystemOptions: document.querySelector('#pdAddToCartSystemOptions'),
		pdHousingOptionAddToCart: document.querySelectorAll('.pdHousingOptionAddToCart'),
		pdAddToCartSticky: document.querySelector('#pdAddToCartSticky'),
		pdAddToCartStickyFaceplate: document.querySelector('#pdAddToCartStickyFaceplate')
	};

	const helpers = {
		addToCartReduceQty,

		openQuantityReduced,

		addItemsToCart: (data, $el) => {

			$el.addClass('loading disabled noPointerEvents');

			let sortParams = formatReferringSortData(sortPath, sortPosition, sortSku, listType);

			// if directly coming to a PDP page then sortParams is not set.
			if (!sortParams) {

				sortParams = {
					SortSku: data[0].ShortSku,
					ListType: window.utag_data.list_type ? window.utag_data.list_type : undefined
				};

			}

			// Add the sort page SearchSkuCount in Session to refer to it on Cart Page.
			// Needs to delete this key from the session on the cart page once it is used.
			if (searchSkuCount) {

				sessionStorage.setItem('searchSkuCount', searchSkuCount);

			}

			// add store number
			helpers.addStoreNumberIfPickup(data);

			// add installation provider sku (if any and if checked)
			helpers.addInstallationSku(data);

			const waitForDataCaptureAndRedirectToCart = () => {

				const promoCode = document.getElementById('promoCouponCodeCheckbox');
				const queryStringParams = promoCode && promoCode.checked ? `a=${promoCode.value}` : '';

				if (!window.lp.globals.enableDataCapture) {

					redirectToCart(queryStringParams);
					return;

				}

				const { reporter } = window.lp.dataCapture;
				const pageImg = document.querySelector('#pdImgContainer');

				const skuViewRequest = reporter.track(Reporter.getSkuViewData(pageImg));

				const atcRecord = reporter.getRecordById(addToCartRecordId);
				const atcRequest = atcRecord.promise;

				// Covers cases where installation is potentially checked by default
				// but the checkbox isn't visible in the screen yet
				const installationCheckbox = document.getElementById('addInstallationChk');
				let installationSkuViewRequest;
				if (installationCheckbox && installationCheckbox.checked) {

					const data = Reporter.getSkuViewData(installationCheckbox);
					installationSkuViewRequest = reporter.track(data);

				}

				const timeout = window.setTimeout(() => redirectToCart(queryStringParams), dataCaptureTimeout);
				Promise.all([ skuViewRequest, atcRequest, installationSkuViewRequest ]).finally(() => {

					window.clearTimeout(timeout);
					redirectToCart(queryStringParams);

				});

			};

			addToCart({
				arrData: data,
				successCallback: waitForDataCaptureAndRedirectToCart,
				errorCallback: (errors, xhr, response) => {

					showAddToCartFailureModal({
						cartStatus: errors,
						response,
						fromModal: false
					});
					$el.removeClass('loading disabled noPointerEvents');

				},
				includeCartOverview: false,
				rememberLastAddedItem: true,
				sortParams
			});

		},

		addStoreNumberIfPickup: (arrData) => {

			// BOPUS pickup check
			const $storePickupRadio = $('#storePickupRadio');
			if ($storePickupRadio.prop('checked')) {

				arrData.forEach((data) => {

					data.PickupStoreNumber = Number($storePickupRadio.val());

				});

			}

		},

		addInstallationSku: (arrData) => {

			const addInstallationCheckbox = document.getElementById('addInstallationChk');
			if (addInstallationCheckbox && addInstallationCheckbox.checked) {

				arrData.forEach((data) => {

					// add Installation Sku to the main product
					if (data.ShortSku === window.shortSku) {

						data.InstallationSku = addInstallationCheckbox.value;
						return false;

					}
					return true;

				});

			}

		},

		setMaskValue: (val) => {

			const $lblProductMaskNumber = $('#lblProductMaskNumber');
			if (val && val.length > 0) {

				$lblProductMaskNumber.css('visibility', 'visible').text(val);

			} else {

				$lblProductMaskNumber.css('visibility', 'hidden').text('');

			}

		},

		findMask: (el) => el.closest('.multiProdSizeOptions__option').find('[id^=txtHiddenMask_]').val(),

		setMultiValue: (val) => {

			$('#lblMultiHospitalGradeInventory').text(val);

		},

		findMultiValue: (el) => el.closest('.multiProdSizeOptions__option').find('[id^=txtHiddenInventory_]').val(),

		isGiftCardFormInvalid: () => {

			const $giftCardForm = $('#giftCardForm');
			return $giftCardForm.length > 0 && !$giftCardForm.valid();

		},

		getGiftCardAddToCartInfo: () => {

			const $giftCardAmountRadio = $('.giftCardAmountRadio');
			if ($giftCardAmountRadio.length > 0) {

				const $selectedGiftCard = $giftCardAmountRadio.filter(':checked');
				const $giftCardEmail = $('#giftCardEmail');
				const giftCardInfo = {
					ShortSku: $selectedGiftCard.attr('data-sku'),
					Quantity: 1,
					GiftCardProductInfo: {
						Amount: Number($selectedGiftCard.val()),
						RecipientFirstName: $('#giftCardFirstName').val().trim(),
						RecipientLastName: $('#giftCardLastName').val().trim(),
						Message: $('#giftCardMessage').val().trim()
					},
					SkuInputType: $selectedGiftCard.attr('data-sku-input-type')
				};

				// e-Gift Card
				if ($giftCardEmail.length > 0) {

					giftCardInfo.GiftCardProductInfo.RecipientEmail = $giftCardEmail.val().trim();

				}

				return [ giftCardInfo ];

			}
			return null;

		},
		trackAddToCart: (data, addToCartBtn, qty) => {

			if (!window.lp.globals.enableDataCapture) {

				return;

			}

			const installationCheckbox = document.getElementById('addInstallationChk');
			const installationCartData = [];

			if (installationCheckbox && installationCheckbox.checked) {

				const installationSku = installationCheckbox.getAttribute('data-sku');
				if (installationSku !== null) {

					installationCartData.push({ ShortSku: installationSku, Quantity: qty });

				}

			}

			const { reporter } = window.lp.dataCapture;
			reporter.trackAddToCart([ ...data, ...installationCartData ], addToCartBtn);
			addToCartRecordId = reporter.getLastRecordId();

		}
	};

	const events = {
		handleAddToCartProduct: (e) => {

			e.preventDefault();
			const giftCardForm = document.querySelector('#giftCardForm');

			// Gift Card validation
			if (helpers.isGiftCardFormInvalid()) {

				giftCardForm?.querySelector('input.error')?.focus();
				return false;

			}

			const $qtyNormal = $('#QtyNormal');
			const $e = $(e.currentTarget);
			const qtyBefore = $('#availInventory').html() || $('.inventoryAvailable').html();
			const multiProdInput = document.querySelector('.multiProdSizeOptions input[type=radio]:checked');
			const price = multiProdInput
				? multiProdInput.getAttribute('data-price')
				: window.utag_data.product_price[0];
			let arrData = [];
			const testCompositionId =				(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;
			let qty = Number($qtyNormal.val());
			const addToCartButton = $e.length ? $e[0] : document.querySelector('#pdAddToCart');

			if (window.checkQuantity && (qty > window.inventory || qty === 0)) {

				helpers.openQuantityReduced(window.inventory);
				$qtyNormal.val(window.inventory);
				return false;

			}

			if (!qty) {

				qty = 1;
				$qtyNormal.val(qty);

			}

			if (qtyBefore) {

				helpers.addToCartReduceQty(qtyBefore, qty);

			}

			// get Gift Card data first, if any
			arrData = helpers.getGiftCardAddToCartInfo() || [
				{
					ShortSku: window.shortSku,
					Price: price,
					Quantity: qty,
					TestCompositionId: testCompositionId,
					PatternColorCombination: decodePatternColorCombination(window.patternSerial) || '',
					IsOpenBox: isOpenBox,
					SkuInputType: addToCartButton?.dataset.skuInputType
				}
			];

			// BOPUS pickup check
			const $storePickupRadio = $('#storePickupRadio');
			if ($storePickupRadio.prop('checked')) {

				arrData[0].PickupStoreNumber = $storePickupRadio.val();

			}

			// Slope Adapter
			const $slopeAdapterCheck = $('input[name=slopeAdapter]');

			if ($slopeAdapterCheck.length) {

				const selectedCheckBox = $('input[name=slopeAdapter]:checked');
				const slopeAdapterSku = selectedCheckBox.val();
				const skuInputType = selectedCheckBox.data('sku-input-type');

				if (Number(slopeAdapterSku) !== 0 && typeof slopeAdapterSku !== 'undefined') {

					arrData.push({
						ShortSku: slopeAdapterSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: skuInputType
					});

				}

			}
			// Custom Downrod
			const $customDownrodRadio = $('input[name=downrodOption]');

			if ($customDownrodRadio.length) {

				const skuInputType = $('input[name=downrodOption]:checked').data('sku-input-type');
				const downrodSku = $('input[name=downrodOption]:checked', '.downrodOptions').val();
				if (Number(downrodSku) !== 0) {

					arrData.push({
						ShortSku: downrodSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: skuInputType
					});

				}

			}

			// Optional Controls
			const $optionalControls = $('input[name=optionalControls]');

			if ($optionalControls.length) {

				const selectedCheckBox = $('input[name=optionalControls]:checked');
				const controlsSku = selectedCheckBox.val();
				const skuInputType = selectedCheckBox.data('sku-input-type');
				if (Number(controlsSku) !== 0 && typeof controlsSku !== 'undefined') {

					arrData.push({
						ShortSku: controlsSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: skuInputType
					});

				}

			}

			const workStationBases = document.querySelectorAll('input[name="workStationBases"]');

			workStationBases.forEach((workStationBase) => {

				if (workStationBase.checked) {

					const workStationBasesSku = workStationBase.value;
					const skuInputType = $('input[name="workStationBases"]:checked').data('sku-input-type');
					if (Number(workStationBasesSku) !== 0 && typeof workStationBasesSku !== 'undefined') {

						arrData.push({
							ShortSku: workStationBasesSku,
							Quantity: qty,
							TestCompositionId: testCompositionId,
							SkuInputType: skuInputType
						});

					}

				}

			});

			helpers.trackAddToCart(arrData, addToCartButton, qty);

			if (window.top.DY) {

				try {

					if (arrData[0].GiftCardProductInfo) {

						trackAddToCartDy(arrData[0].ShortSku, parseFloat((arrData[0].GiftCardProductInfo.Amount * qty).toFixed(2)), qty);

					} else {

						trackAddToCartDy(window.shortSku, parseFloat((window.utag_data.product_price[0] * qty).toFixed(2)), qty);

					}

				} catch (e) {

					console.warn('DY API is not available', e);

				}

			}

			helpers.addItemsToCart(arrData, $(addToCartButton));
			return true;

		},
		handleAddToCartDimmer: (e) => {

			e.preventDefault();

			const $qtyDimmerCombo = $('#QtyDimmerCombo');
			const $e = $(e.currentTarget);
			let qty = Number($qtyDimmerCombo.val());
			const testCompositionId =				(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;

			if (window.checkQuantity && (qty > Number(window.inventory) || qty === 0)) {

				helpers.openQuantityReduced(window.inventory);
				$qtyDimmerCombo.val(window.inventory);
				return false;

			}

			const $facePlateOption = $('#dimmerWithFacePlateOption');
			const qtyBefore = $('#availInventory').html() || $('.inventoryAvailable').html();

			if (!qty) {

				qty = 1;
				$qtyDimmerCombo.val(qty);

			}

			const arrData = $facePlateOption.prop('checked')
				? [
					{
						ShortSku: window.shortSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: $e[0]?.dataset.skuInputType
					},
					{
						ShortSku: $facePlateOption.val(),
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: $facePlateOption[0]?.dataset.skuInputType
					}
				  ]
				: [
					{
						ShortSku: window.shortSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: $e[0]?.dataset.skuInputType
					}
				  ];

			if (qtyBefore) {

				helpers.addToCartReduceQty(qtyBefore, qty);

			}

			helpers.trackAddToCart(arrData, $e[0], qty);

			helpers.addItemsToCart(arrData, $e);

		},
		handleAddToCartMultiProduct: (e) => {

			e.preventDefault();

			const $qtyMultiProd = $('#QtyMultiProd');
			const $multiProdInput = $('.multiProdSizeOptions input[type=radio]:checked');
			let qty = Number($qtyMultiProd.val());
			const testCompositionId =				(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;
			const arrData = [
				{
					ShortSku: String($multiProdInput.data('sku')),
					Price: $multiProdInput.data('price'),
					Quantity: qty,
					TestCompositionId: testCompositionId,
					IsOpenBox: isOpenBox,
					SkuInputType: $multiProdInput.data('skuInputType'),
					IsMultiProduct: true
				}
			];

			if (!qty) {

				qty = 1;
				$qtyMultiProd.val(qty);

			}

			const qtyBefore = $('#availInventory').html() || $('.inventoryAvailable').html();

			if (qtyBefore) {

				helpers.addToCartReduceQty(qtyBefore, qty);

			}

			helpers.trackAddToCart(arrData, e.currentTarget, qty);

			helpers.addItemsToCart(arrData, $(e.currentTarget));

			if (window.top.DY) {

				try {

					trackAddToCartDy($multiProdInput.data('sku'), parseFloat(($multiProdInput.data('price') * qty).toFixed(2)), qty);

				} catch (e) {

					console.warn('DY API is not available', e);

				}

			}

		},
		handleAddToCartSystemOptions: (e) => {

			e.preventDefault();

			const $pdFullSystemOptions = $('#pdFullSystemOptions');
			const $e = $(e.currentTarget);
			const testCompositionId =				(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;
			const arrShortSKUs = [];
			const arrQuantities = [];
			const arrProductNames = [];
			const arrProductPrices = [];
			const arrProductCategories = [];
			const arrProductBrands = [];
			const arrProductStyles = [];
			const arrSystemOption = [];
			const arrSkuInputType = [];
			const arrData = [];
			let qtyToAdd = 0;
			let qtyBefore;
			let available;
			let i;

			$pdFullSystemOptions.find('input:text.systemOptionsQty').each(function () {

				if (this.value !== '' && this.value >= 1) {

					arrSystemOption.push(this.id !== 'txtItems_0');
					arrShortSKUs.push(this.dataset.shortsku);
					arrQuantities.push(this.value);
					arrProductNames.push(this.dataset.name);
					arrProductPrices.push(this.dataset.price);
					arrProductCategories.push(this.dataset.category);
					arrProductBrands.push(this.dataset.brand);
					arrProductStyles.push(this.dataset.style);
					arrSkuInputType.push(this.dataset.skuInputType);

				}

			});

			// Add to cart if all quantities are available

			// update quantity available for product on page via it's item representation
			qtyToAdd = parseInt($('#txtItems_0').val(), 10);

			if (qtyToAdd > 0) {

				qtyBefore = $('availInventory').html() || $('.inventoryAvailable').html();

				if (qtyBefore) {

					helpers.addToCartReduceQty(qtyBefore, qtyToAdd);

				}

			}

			// update quantities available, except product page, which updates from addToCartReduceQty()
			$pdFullSystemOptions.find('input:text.systemOptionsQty:not(#txtItems_0)').each(function () {

				available = $(this).attr('data-inventory') - $(this).val();

				$(this).attr('data-inventory', available);

			});

			if (arrQuantities.length > 0) {

				for (i = 0; i < arrQuantities.length; i += 1) {

					arrData.push({
						SystemOption: arrSystemOption[i],
						ShortSku: arrShortSKUs[i],
						Quantity: arrQuantities[i],
						Name: arrProductNames[i],
						Price: arrProductPrices[i],
						Category: arrProductCategories[i],
						Brand: arrProductBrands[i],
						Style: arrProductStyles[i],
						TestCompositionId: testCompositionId,
						SkuInputType: arrSkuInputType[i]
					});

					if (window.top.DY) {

						try {

							trackAddToCartDy(arrShortSKUs[i], parseFloat((arrQuantities[i] * arrProductPrices[i]).toFixed(2)), arrQuantities[i]);

						} catch (e) {

							console.warn('DY API is not available', e);

						}

					}

				}

				const { reporter } = window.lp.dataCapture;
				const addToCartButton = $e.length ? $e[0] : document.querySelector('#pdAddToCartSystemOptions');

				if (window.lp.globals.enableDataCapture) {

					// If full system options support installation, please use helpers.trackAddToCart
					reporter.trackAddToCart(arrData, addToCartButton);
					addToCartRecordId = reporter.getLastRecordId();

				}

				utagLinkPDP()({
					eventAction: `Click-BFS-${window.utag_data.product_category[0]}-Add-To-Cart`,
					eventLabel: `${window.location.pathname}-${arrData.map((p) => p.ShortSku).join(',')}`
				});

				helpers.addItemsToCart(arrData, $(addToCartButton));

			} else {

				showErrorMessage({
					errors: 'Please enter a quantity for one or more products.',
					title: '',
					modal: {
						height: 80
					}
				});

			}

		},
		handleAddToCartHousingOption: (e) => {

			e.preventDefault();

			const $parentUI = $(e.target).closest('[data-shortsku]');
			const shortSku = $parentUI.attr('data-shortsku');
			const trimShortSku = $parentUI.attr('data-trim-shortsku');
			const skuInputType = $parentUI.attr('data-sku-input-type');
			const qty = $parentUI.find('[name=qty]').val();
			const testCompositionId =				(window.utag_data.testcomposition_id && window.utag_data.testcomposition_id[0]) || null;
			const products = [];

			if (shortSku.length > 0 && qty > 0) {

				// Housing product
				products.push({
					ShortSku: shortSku,
					Quantity: qty,
					TestCompositionId: testCompositionId,
					SkuInputType: skuInputType
				});

				// Trim product
				if (trimShortSku.length > 0) {

					products.push({
						ShortSku: trimShortSku,
						Quantity: qty,
						TestCompositionId: testCompositionId,
						SkuInputType: skuInputType
					});

				}

			}

			if (products.length > 0) {

				const { reporter } = window.lp.dataCapture;
				const addToCartButton = e.target;

				if (window.lp.globals.enableDataCapture) {

					// If housing options support installation, please use helpers.trackAddToCart
					reporter.trackAddToCart(products, addToCartButton);
					addToCartRecordId = reporter.getLastRecordId();

				}

				helpers.addItemsToCart(products, $(addToCartButton));

				if (window.top.DY) {

					try {

						trackAddToCartDy(shortSku, $parentUI.attr('data-price') * qty, qty * 2);

					} catch (e) {

						console.warn('DY API is not available', e);

					}

				}

			}

		},
		handleUpdateProductQty: (e) => {

			const { currentTarget } = e;
			if (currentTarget.checked) {

				const newMultiValue = helpers.findMultiValue($(currentTarget));
				const maskValue = helpers.findMask($(currentTarget));

				helpers.setMultiValue(newMultiValue);
				helpers.setMaskValue(maskValue);

			}

		}
	};

	function init () {

		// globals

		const { isHospitality } = window.lp.globals;

		const {
			pdAddToCart,
			pdAddToCartSticky,
			pdAddDimmer,
			pdAddMultiProduct,
			pdMultiProductRadios,
			pdAddToCartSystemOptions,
			pdHousingOptionAddToCart,
			pdAddToCartStickyFaceplate
		} = ui;

		const {
			handleAddToCartProduct,
			handleAddToCartDimmer,
			handleAddToCartMultiProduct,
			handleAddToCartSystemOptions,
			handleAddToCartHousingOption,
			handleUpdateProductQty
		} = events;

		// normal
		if (pdAddToCart) {

			pdAddToCart.addEventListener('click', handleAddToCartProduct);

		}
		if (pdAddToCartSticky) {

			pdAddToCartSticky.addEventListener('click', handleAddToCartProduct);

		}
		// dimmer
		if (pdAddDimmer) {

			pdAddDimmer.addEventListener('click', handleAddToCartDimmer);

		}
		if (pdAddToCartStickyFaceplate) {

			pdAddToCartStickyFaceplate.addEventListener('click', handleAddToCartDimmer);

		}
		// multi-product
		if (pdAddMultiProduct) {

			pdAddMultiProduct.addEventListener('click', handleAddToCartMultiProduct);

		}
		// housing options
		if (pdHousingOptionAddToCart.length) {

			pdHousingOptionAddToCart.forEach((option) => {

				option.addEventListener('click', handleAddToCartHousingOption);

			});

		}

		// system options
		if (pdAddToCartSystemOptions) {

			pdAddToCartSystemOptions.addEventListener('click', handleAddToCartSystemOptions);

		}

		// Update multiple quantities for Hospitality
		if (isHospitality && pdMultiProductRadios) {

			pdMultiProductRadios.forEach((radio) => {

				radio.addEventListener('change', handleUpdateProductQty);

			});

		}

	}

	return Object.freeze({ init });

}

export default initCart;
